export default {
  meta: {
    title: '周报提交记录',
    url: '/abside/weekrecord', // 埋点字段，上报归属的模块
    urlName: 'ab侧-周报提交记录', // 埋点字段，上报归属的模块
    logincallback: '/abside',
  }
};
